import React, { useState, useEffect } from "react";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box, IconButton } from "@mui/material";
import { HeaderConfig, InfantCareTrackingHeaderConfig } from "./config";
import CustomButtonComponent from "../../../../core/custom-button";
import CustomTable from "../../../../core/custom-table";
import InfantCareFilters from "./infant-care-filters";
import { exportToExcel, PAGE_LIMIT } from "../../../../utils";
import DeleteModal from "../../../../components/delete-modal";
import EditInfantCare from "./edit-infantcare";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const InfantCareTracking = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });
  const [edit, setEdit] = useState({ isOpen: false, data: {} });
  const [isDelete, setIsDelete] = useState({ isOpen: false, data: {} });

  const ClickHandler = (type, data) => {
    switch (type) {
      case "EDIT":
        setEdit({
          isOpen: true,
          data: data,
        });

        break;
      case "DELETE":
        setIsDelete({ isOpen: true, data: data });
        break;
      default:
        break;
    }
  };
  const deleteHandler = () => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${HOSTNAME}${REST_URLS.INFANT_CARE}/${isDelete?.data?.id}`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Deleted Successfully");
          setIsDelete({ isOpen: false, data: {} });
          loadData(filters);
        }
      })
      .catch((err) => console.error(err));
  };
  const downloadReports = () => {
    const params = {
      download: "TRUE",
    };
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.INFANT_CARE}`,
      null,
      params,
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Infant care.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  const loadData = (filters) => {
    const payload = { ...filters };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.INFANT_CARE}`,
      null,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        {edit?.isOpen && (
          <IconButton
            onClick={() => {
              setEdit({ isOpen: false, data: {} });
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <div>
          <p className="tab-name">Analysis</p>
          <p className="section-name">Infant Care Tracking</p>
        </div>
      </div>
      {edit?.isOpen ? (
        <EditInfantCare
          loadData={loadData}
          setIsCreate={setEdit}
          editData={edit?.data}
        />
      ) : (
        <>
          <div>
            {data?.results?.length > 0 && (
              <div className="create-con">
                <p className="primary-text">Infant Care Report</p>
                <Box sx={{ display: "flex", gridGap: "20px" }}>
                  <CustomButtonComponent
                    variant="contained"
                    color="success"
                    onClick={downloadReports}
                  >
                    Download Report
                  </CustomButtonComponent>
                </Box>
              </div>
            )}
            <div className="si-hide-mobile">
              <CustomTable
                header={InfantCareTrackingHeaderConfig}
                data={data.results || []}
                pageCount={data.totalPages}
                filters={filters}
                onChange={(page) => {
                  setFilters({
                    ...filters,
                    page,
                  });
                  loadData({
                    ...filters,
                    page,
                  });
                }}
                filterCom={<InfantCareFilters loadData={loadData} />}
                onClick={ClickHandler}
                isLoading={isLoading}
              />
            </div>
          </div>
        </>
      )}
      {isDelete?.isOpen && (
        <DeleteModal
          deleteHandler={deleteHandler}
          onClose={() => {
            setIsDelete({ isOpen: false, data: {} });
          }}
        />
      )}
    </div>
  );
};
export default InfantCareTracking;
